<template>
    <modal name="PuzzleDetails" @before-open="beforeOpen" @before-close="beforeClose"
        :classes="['v--modal', 'error-modal', 'photo']" :width="960" :height="'auto'" :scrollable="true" :adaptive="true">
        <div>
            <div class="photo-main">
                <div class="photo-header">

                    <redirectButton v-if="puzzleData && puzzleData.album" :pathname="getMethod()" :params="{
                        profileId: puzzleData.owner.id,
                        albumId: puzzleData.album.id,
                    }" :html="$t('profile.puzzles')" class="photo-album">
                    </redirectButton>

                    <span @click="$modal.hide('photo-details')" class="photo-back"></span>
                    <div class="photo-total-count">
                        {{ current + 1 }}
                        {{ $t("photoDetails.from") }}
                        <span v-if="fromEvents">{{ eventCount }}</span>
                        <span v-else>{{ count }}</span>
                    </div>
                    <div class="photo-actions">
                        <!-- <span @click="removePuzzles(selected)">
                            {{ $t("photoDetails.delete") }}
                        </span> -->
                        <!-- <span @click="removePhoto([instanceId], removeCallback)">
                            {{ $t("photoDetails.delete") }}
                        </span> -->
                    </div>
                </div>


                <!-- <div>
                    <button :disabled="!hasPrev" @click="showNext(prevId)" class="photo-arrow prev">
                        <div class="photo-arrow-front card-face">
                            <div class="photo-arrow-image" :style="{
                                'background-image': prevImage ? 'url(' + prevImage + ')' : '',
                            }"></div>
                            <CardFace :suit="suit" :rank="rank"></CardFace>
                        </div>
                        <div class="photo-arrow-back card-shirt"></div>
                    </button>
                    <button :disabled="!hasNext" @click="showNext(nextId)" class="photo-arrow next">
                        <div class="photo-arrow-front card-face">
                            <div class="photo-arrow-image" :style="{
                                'background-image': nextImage ? 'url(' + nextImage + ')' : '',
                            }"></div>
                            <CardFace :suit="suit" :rank="rank"></CardFace>
                        </div>
                        <div class="photo-arrow-back card-shirt"></div>
                    </button>
                </div> -->

                <div v-if="isVideo" ref="instance" class="photo-wrapper photo-wrapper-video">
                    <span v-if="instanceLoader">
                        {{ $t("photoDetails.loadingVideo") }}
                    </span>
                    <video v-else-if="puzzleData.image" controls :poster="puzzleData.image" :preload="metadata"
                        class="photo-video">
                        {{ $t("photoDetails.yourBrowserSupportHTML5Video") }}
                    </video>
                    <div v-else-if="puzzleData.ready" class="photo-process">
                        {{ $t("photoDetails.videoProcessingError") }}
                    </div>
                    <div v-else class="photo-process">
                        {{ $t("photoDetails.videoProcessing") }}
                    </div>
                </div>
                <div v-else ref="instance" class="photo-wrapper">
                    <span v-if="instanceLoader">
                        {{ $t("photoDetails.uploadingPhoto") }}
                    </span>
                    <img v-else :src="puzzleData.image" alt="" class="photo-img" />
                </div>
            </div>

            <div class="photo-bottom">
                <div class="photo-info photo-bottom-item">
                    <div class="photo-info-row">
                        <div v-if="puzzleData.owner" class="user-item" :class="{
                            online: puzzleData.owner.online,
                        }">
                            <router-link :to="'/profile/' + puzzleData.owner.id" :style="{
                                'background-image': puzzleData.owner.avatar
                                    ? 'url(' + puzzleData.owner.avatar + ')'
                                    : '',
                            }" class="user-item-avatar" :class="{ 'no-avatar': !puzzleData.owner.avatar }"></router-link>
                            <div class="user-item-info">
                                <router-link :to="'/profile/' + puzzleData.owner.id" class="user-item-title">{{
                                    puzzleData.owner.name }}</router-link>
                                <div class="user-item-bottom">
                                    <!-- {{ getVerbalDate(myPuzzle.time * 1000) }} -->
                                    <!-- {{ getVerbalDate(instance.time * 1000) }} -->
                                </div>
                            </div>
                        </div>
                        <div class="photo-votes">
                            <button v-if="voteLoader" class="photo-vote photo-vote-loader"></button>
                            <button v-else @click="vote(instanceId)" :disabled="puzzleData.owner && puzzleData.owner.id == user.id"
                                class="photo-vote" :class="{ 'photo-vote-liked': puzzleData.liked }">
                                <SvgIcon name="like"></SvgIcon>
                            </button>
                            <div class="photo-votes-count">{{ puzzleData.likes }}</div>
                        </div>
                    </div>
                    <div v-if="puzzleData.owner && puzzleData.owner.id != user.id && puzzleData.description" class="photo-description">
                        <span class="photo-description-text">{{
                            puzzleData.description
                        }}</span>
                    </div>
                    <div v-else-if="puzzleData.owner && puzzleData.owner.id == user.id" class="photo-description"
                        :class="{ 'photo-description-disabled': descriptionLoader }">
                        <textarea @click="showEditButton = true" wrap="hard" ref="pseudotextarea" class="textarea" :class="{
                            empty: puzzleData.description == '',
                            'textarea-video': isVideo,
                            showEditButton: showEditButton,
                        }" v-model="localDescription"></textarea>
                        <div class="buttons-row photo-description-buttons">
                            <button @click="cancelEdit" class="button-secondary">
                                {{ $t("photoDetails.cancel") }}
                            </button>
                            <button @click="editDescription(puzzleData.id)" class="button">
                                {{ $t("photoDetails.save") }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="photo-comments photo-bottom-item">
                    <div v-if="commentsLoader" class="photo-comments-form vip-only desktop">
                        <button class="button-loader"></button>
                    </div>
                    <div v-if="!commentsIsEmpty('comments')" class="photo-comments-wrapper">
                        <div ref="vBar" class="photo-comments-scrollbar-container">
                            <div class="photo-comments-inner">
                                <div v-for="(comment, index) in comments" :ref="'element' + index"
                                    class="info-block user-item photo-comments-item">
                                    <router-link :to="'/profile/' + comment.owner.id" :style="{
                                        'background-image': comment.owner.avatar
                                            ? 'url(' + comment.owner.avatar + ')'
                                            : '',
                                    }" class="user-item-avatar"
                                        :class="{ 'no-avatar': !comment.owner.avatar }"></router-link>
                                    <div class="user-item-info">
                                        <router-link :to="'/profile/' + comment.owner.id" class="user-item-title">{{
                                            comment.owner.name }}</router-link>
                                        <div class="user-item-subtitle">{{ comment.text }}</div>
                                        <div class="user-item-bottom">
                                            {{ getVerbalDate(comment.time * 1000) }}
                                        </div>
                                    </div>
                                    <div class="user-item-right">
                                        <button v-if="deleteLoader" class="delete delete-loader"></button>
                                        <button v-else-if="comment.owner.id == user.id ||
                                            (puzzleData.owner && puzzleData.owner.id == user.id)
                                            " @click="deleteComment(comment.id)" class="delete"></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="photo-comments-wrapper">
                        <div class="photo-comments-inner photo-comments-empty">
                            {{ $t("photoDetails.noCommentsYet") }}
                        </div>
                    </div>
                    <div v-if="moreCommentsLoader">
                        <button class="button-loader"></button>
                    </div>

                    <div v-if="commentsLoader" class="photo-comments-form vip-only mobile">
                        <button class="button-loader"></button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import SvgIcon from "@/components/SvgSprite";
import { removePhoto } from "@/mixins/removePhoto";
import CardFace from "@/components/Blocks/CardFace";
import { formatDateTime } from "@/mixins/formatDateTime";
import { checkScroll } from "@/mixins/checkScroll";
import { randomInteger } from "@/mixins/randomInteger";
import { observeListEnd } from "@/mixins/observeListEnd";
import { handleSwipe } from "@/mixins/handleSwipe";
import { consts } from "@/consts";

export default {
    name: "PuzzleDetails",
    props: {
        myPuzzle: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        description: {
            type: String,
            required: false,
            default: '',
        },
        i18n: Object,
    },
    components: {
        SvgIcon,
        CardFace,
    },
    mixins: [
        removePhoto,
        formatDateTime,
        checkScroll,
        randomInteger,
        observeListEnd,
        handleSwipe
    ],
    data() {
        return {
            showContext: false,
            showModal: false,

            feed: false,
            instanceLoader: true,
            commentsLoader: true,
            hasBugs: false,
            instanceId: "",
            albumId: "",
            text: "",
            current: "",
            nextId: "",
            nextImage: "",
            prevId: "",
            prevImage: "",
            newAlbumTitle: "",
            fromEvents: false,
            hasNext: true,
            hasPrev: true,
            eventCount: null,
            eventArr: null,
            ranks: consts.card_ranks,
            suit: 1,
            rank: 7,
            voteLoader: false,
            localDescription: "",
            showCommentForm: false,
            showEditButton: false,
            commentLoader: false,
            moreCommentsLoader: false,
            deleteLoader: false,
            vipOnly: false,
            descriptionLoader: false,
            moreIndex: 0,
            observer: null,
            swipe: false,
            descMaxLength: 150,
            lastText: undefined,
            lastOffset: undefined,
            valueSetter: "",
            value: "",
            isVideo: false,

            prevDescription: "",
            monthsTranslation: {
                january: this.$t("months.january"),
                february: this.$t("months.february"),
                march: this.$t("months.march"),
                april: this.$t("months.april"),
                may: this.$t("months.may"),
                june: this.$t("months.june"),
                july: this.$t("months.july"),
                august: this.$t("months.august"),
                september: this.$t("months.september"),
                october: this.$t("months.october"),
                november: this.$t("months.november"),
                december: this.$t("months.december"),
            },
        };
    },
    computed: {
        ...mapGetters({
            myPuzzles: "myPuzzles/fetchMyPuzzles",
            init: "init/fetchInit",
            initIsEmpty: "init/isEmpty",
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
            bought: "puzzles/fetchBought",
            myPuzzlesCount: "myPuzzles/fetchMyPuzzlesCount",
            selected: "myPuzzles/fetchMyPuzzlesSelected",
        }),
        // Безопасный доступ к данным пазла (либо из props, либо из store)
        puzzleData() {
            const inst = this.instance;
            if (
                inst &&
                Object.keys(inst).length &&
                (inst.id === this.instanceId ||
                    (this.myPuzzle && inst.id === this.myPuzzle.id))
            ) {
                return inst;
            }
            return this.myPuzzle || {};
        },
        instance() {
            return this.$store.getters["myPuzzles/fetchMyPuzzlesDetails"];
        },
        instances() {
            return this.myPuzzles;
        },
        instancesIsEmpty() {
            const isEmpty = this.$store.getters[this.getMethod() + "/fetchMyPuzzles"];
            console.log(isEmpty);
            return isEmpty;
        },
        instanceErrors() {
            return this.$store.getters["myPuzzles/errors"];
        },
        instancesErrors() {
            return this.$store.getters[this.getMethod() + "/errors"];
        },
        count() {
            return this.myPuzzlesCount;
        },
        commentsIsEmpty() {
            return this.$store.getters[this.getCommentsMethod() + "/isEmpty"];
        },
        comments() {
            return this.$store.getters[
                this.getCommentsMethod() +
                "/fetch" +
                this.getMethod(true, "", false) +
                "Comments"
            ];
        },
        commentsErrors() {
            return this.$store.getters[this.getCommentsMethod() + "/errors"];
        },
        commentsIsEmpty() {
            return this.$store.getters[this.getCommentsMethod() + "/isEmpty"];
        },
        nextComments() {
            return this.$store.getters[
                this.getCommentsMethod() +
                "/fetch" +
                this.getMethod(true, "", false) +
                "CommentsNext"
            ];
        },
    },
    methods: {
        getMethod(capitalize = false, method = "", isPlural = true) {
            let str = this.isVideo ? "video" : "photo";
            if (capitalize) str = str.charAt(0).toUpperCase() + str.slice(1);
            if (isPlural) str += "s";
            return str + method;
        },
        beforeOpen(event) {
            // Защита от undefined params
            if (!event || !event.params) {
                console.error('PuzzleDetails: event.params is undefined');
                return;
            }
            
            this.feed = event.params.feed || false;
            this.isVideo = event.params.isVideo || false;
            this.checkScroll();
            this.fromEvents = false;
            this.instanceId = event.params.id;
            this.initInstance();
            if (event.params.fromEvents) {
                this.fromEvents = true;
                this.eventArr = event.params.eventArr || null;
                if (this.eventArr) {
                    this.calcPrevNext();
                } else {
                    this.current = 0;
                    this.eventCount = 1;
                }
            } else if (this.feed) {
                this.current = 0;
                this.eventCount = 1;
            } else {
                this.calcPrevNext();
            }
            if (event.params.isAlbum) {
                this.$store.dispatch(this.getMethod(false, "/setIsAlbum"), true);
            }
        },
        initInstance() {
            this.instanceLoader = true;
            this.commentsLoader = true;
            this.nextId = "";
            this.prevId = "";
            if (this.myPuzzle && Object.keys(this.myPuzzle).length) {
                this.instanceLoader = false;
                this.commentsLoader = false;
                this.localDescription = this.myPuzzle.description || "";
                return;
            }
            this.getInstance();
            this.rank = this.ranks[this.randomInteger(0, 8)];
            this.suit = this.randomInteger(1, 4);
            this.observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting === true) {
                        this.showMoreComments();
                    }
                },
                { threshold: [0] }
            );
        },
        getInstance() {
            this.$store
                .dispatch("myPuzzles/getDetails", this.instanceId)
                .then(() => {
                    this.instanceLoader = false;
                    this.localDescription = this.instance.description;
                    this.commentsLoader = false;

                    if (this.instance.owner.id == this.user.id) {
                        let msie = window.document.documentMode;
                        setTimeout(() => {
                            this.$refs.pseudotextarea.innerText = this.instance.description;
                            let textarea = this.$refs.pseudotextarea;
                            if (msie) {
                                textarea.addEventListener("keydown", this.onKeydown);
                            } else {
                                textarea.addEventListener("input", this.onKeydown);
                            }
                        }, 500);
                    }

                    if (this.swipe) {
                        return;
                    }
                    this.initSwipe();
                })
                .catch(() => {
                    this.instanceLoader = false;
                    this.commentsLoader = false;
                    if (!(this.myPuzzle && Object.keys(this.myPuzzle).length)) {
                        this.$modal.hide("photo-details");
                        let text =
                            this.instanceErrors && this.instanceErrors.vip_settings == 1
                                ? this.getText() + this.$t("photoDetails.noCommentsYetVip")
                                : this.getText() + this.$t("photoDetails.deletedUnavailable");
                        this.$modal.show("dialog", {
                            title: this.$t("login.error"),
                            text: text,
                            buttons: [{ title: this.$t("roulette.ok") }],
                        });
                    }
                });
        },
        getText() {
            return this.isVideo
                ? this.$t("photoDetails.video")
                : this.$t("photoDetails.photo");
        },
        calcPrevNext() {
            const listLength = this.instances.length;
            if (listLength <= 1 || this.feed) {
                this.current = 0;
                this.hasPrev = false;
                this.hasNext = false;
                this.prevId = "";
                this.nextId = "";
                return;
            }
            let arr = [];
            let instancesArr = this.fromEvents ? this.eventArr : this.instances;
            this.eventCount = this.eventArr ? this.eventArr.length : null;
            for (let i in instancesArr) {
                arr.push(instancesArr[i].id);
            }

            let calcCurrent = () => {
                for (let j in this.instances) {
                    if (this.instances[j].id == this.instanceId) {
                        return parseInt(j);
                    }
                }
            };

            this.current = this.fromEvents
                ? arr.indexOf(this.instanceId)
                : calcCurrent();

            let calcPrevId = () => {
                if (this.current > 0) {
                    this.prevId = this.instances[this.current - 1].id;
                    this.prevImage = this.instances[this.current - 1].image;
                } else {
                    this.prevId = this.instances[listLength - 1].id;
                    this.prevImage = this.instances[listLength - 1].image;
                }
            };

            let calcNextIdImage = () => {
                if (this.current < listLength - 1) {
                    this.nextId = this.instances[this.current + 1].id;
                    this.nextImage = this.instances[this.current + 1].image;
                } else {
                    this.nextId = this.instances[0].id;
                    this.nextImage = this.instances[0].image;
                }
            };

            if (!this.fromEvents) {
                let prevCheck =
                    this.current >= 2 ? this.current - 2 : listLength + this.current - 2;

                let nextCheck =
                    this.current < listLength - 2
                        ? this.current + 2
                        : this.current - listLength + 2;

                if (!this.instances[prevCheck]) {
                    this.hasPrev = false;
                    this.prevId = "";
                    this.prevImage = "";
                } else {
                    this.hasPrev = true;
                    calcPrevId();
                }

                if (!this.instances[nextCheck]) {
                    this.hasNext = false;
                    this.nextId = "";
                    this.nextImage = "";
                } else {
                    this.hasNext = true;
                    calcNextIdImage();
                }
            } else {
                this.nextId =
                    this.current < arr.length - 1 ? arr[this.current + 1] : arr[0];

                this.nextImage =
                    this.current < arr.length - 1
                        ? instancesArr[this.current + 1].image
                        : instancesArr[0].image;

                this.prevId =
                    this.current > 0 ? arr[this.current - 1] : arr[arr.length - 1];

                this.prevImage =
                    this.current > 0
                        ? arr[this.current - 1].image
                        : arr[arr.length - 1].image;
            }
        },
        initSwipe() {
            let self = this;
            this.handleSwipe(
                this.$refs.instance,
                function () {
                    return self.checkNext(true);
                },
                function () {
                    return self.checkNext(false);
                }
            );
            this.swipe = true;
        },
        create() {
            let self = this;
            this.$validator.validateAll().then((valid) => {
                if (valid && this.instanceArr.length) {
                    this.loader = true;
                    if (this.album || this.albumId) {
                        let currentAlbum = this.album ? this.album.id : this.albumId;
                        for (let i in this.instanceArr) {
                            this.instanceArr[i].album = currentAlbum;
                            this.instanceArr[i].description = this.description;
                        }
                    }
                    this.$store
                        .dispatch(this.getMethod(false, "/create"), this.instanceArr)
                        .then(() => {
                            this.resetInstances();
                            this.$modal.hide("upload-photos");
                            this.loader = false;
                        })
                        .catch(() => {
                            if (typeof this.instancesErrors === "object") {
                                let text = "";
                                for (let i in this.instancesErrors) {
                                    for (let key in this.instancesErrors[i]) {
                                        text += this.instancesErrors[i][key][0];
                                        text += "<br>";
                                    }
                                }
                                this.$modal.show("dialog", {
                                    title: "Предупреждение!",
                                    text: text,
                                    buttons: [
                                        {
                                            title: "ОК",
                                        },
                                    ],
                                });
                            }
                            this.loader = false;
                        });
                }
            });
        },
        select() {
            this.showModal = false;

            this.showContext = false;
            this.$store.dispatch("myPuzzles/select", this.puzzleData.id || this.instanceId);
        },
        clickOutsideContext() {
            this.showContext = false;
        },
        // getVerbalDate(timestamp) {
        //     const date = new Date(timestamp);

        //     const day = date.getDate();
        //     const month = date.toLocaleString("default", { month: "long" });
        //     const time = date.toLocaleTimeString([], {
        //         hour: "2-digit",
        //         minute: "2-digit",
        //     });

        //     return `${day} ${month} в ${time}`;
        // },



        getCommentsMethod(method = "") {
            return (this.isVideo ? "videoComments" : "comments") + method;
        },
        showMoreComments() {
            if (this.nextComments) {
                this.moreCommentsLoader = true;
                this.$store
                    .dispatch(this.getCommentsMethod("/getNext"))
                    .then(() => {
                        this.observeListEnd("element", false, true, true);
                        this.moreCommentsLoader = false;
                    })
                    .catch(() => {
                        this.moreCommentsLoader = false;
                    });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
        beforeClose() {
            this.checkRemoveScroll();
            this.$store.dispatch(this.getMethod(false, "/setIsAlbum"), false);
            this.swipe = false;
        },
        editDescription(id) {
            this.showEditButton = false;
            if (this.puzzleData.description === this.localDescription) {
                return;
            }
            this.descriptionLoader = true;
            const albumId =
                (this.puzzleData.album && this.puzzleData.album.id) ||
                (this.myPuzzle && this.myPuzzle.album && this.myPuzzle.album.id) ||
                this.albumId;
            const requestData = [{
                id: this.instanceId || id,
                album: albumId,
                description: this.localDescription,
            }];
            this.$store
                .dispatch(this.getMethod(false, "/updateDescription"), requestData)
                .then(() => {
                    this.puzzleData.description = this.localDescription;
                    this.descriptionLoader = false;
                })
                .catch(() => {
                    this.descriptionLoader = false;
                });
        },
        checkNext(forward) {
            const id = () => {
                return forward ? this.nextId : this.prevId;
            };
            if (id()) {
                this.showNext(id());
            } else {
                this.instanceLoader = true;
                let promise = new Promise((resolve, reject) => {
                    let count = 0;
                    let checkId = () => {
                        setTimeout(() => {
                            if (id()) {
                                resolve();
                            } else if (count < 20) {
                                count++;
                                checkId();
                            } else {
                                reject();
                            }
                        }, 100);
                    };
                    checkId();
                });

                promise
                    .then(() => {
                        this.instanceLoader = false;
                        this.showNext(id());
                    })
                    .catch(() => {
                        this.instanceLoader = false;
                    });
            }
        },
        showNext(id) {
            if (this.$refs.vBar) {
                this.$vuebar.destroyScrollbar(this.$refs.vBar);
            }
            this.instanceId = id;
            this.initInstance();
            this.calcPrevNext();
        },
        checkDescLengthInput(e) {
            let text = this.$refs.pseudotextarea.textContent;
            let selection = window.getSelection();
            let { anchorNode, anchorOffset } = selection;
            anchorOffset = Math.min(anchorOffset, this.descMaxLength);
            if (text.length > this.descMaxLength) {
                if (e.inputType == "insertFromPaste") {
                    text = text.slice(0, this.descMaxLength);
                } else {
                    text = this.lastText || text.slice(0, this.descMaxLength);
                }
                this.$refs.pseudotextarea.textContent = text;
                selection.collapse(anchorNode, this.lastOffset);
                this.placeCaretAtEnd(this.$refs.pseudotextarea);
                return;
            }
            this.lastText = text;
            this.lastOffset = anchorOffset;
            this.$emit("input", text);
        },
        cancelEdit() {
            const textarea = this.$refs.pseudotextarea;
            const newDescription = textarea.innerText;
            if (newDescription !== this.prevDescription) {
                const diffIndex =
                    newDescription.indexOf(this.prevDescription) +
                    this.prevDescription.length;
                textarea.innerText = newDescription.slice(0, diffIndex);
            }
            this.showEditButton = false;
        },
        removePuzzles(arr, callback = false) {
            this.$modal.show("dialog", {
                title: this.$t("threads.warning"),
                text: this.$t("myPuzzles.puzzlesRemoved"),
                buttons: [
                    {
                        title: this.$t("threads.delete"),
                        handler: () => {
                            this.$store
                                .dispatch("myPuzzles/delete", arr)
                                .then(() => {
                                    this.$modal.hide("dialog");
                                    if (callback) {
                                        callback();
                                    }
                                })
                                .catch(() => {
                                    this.$modal.hide("dialog");
                                });
                        },
                    },
                    {
                        title: this.$t("stories.cancel"),
                    },
                ],
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_playing-card";
</style>
